import styles from "./WhiteboardPracticeSelectionNotice.module.css";

export function WhiteboardPracticeSelectionNotice({
  selectionId,
  className = "",
}: {
  selectionId?: number;
  className?: string;
}) {
  return (
    <span
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className={
        selectionId === undefined
          ? "sr-only"
          : `min-w-0 text-xs font-medium normal-case leading-5 text-[#AEAEB2] ${className}`
      }
    >
      {selectionId === undefined ? null : (
        <span key={selectionId} className={styles.notice}>
          Selected for whiteboard practice
        </span>
      )}
    </span>
  );
}
